/*
 * @Author: your name
 * @Date: 2021-05-18 08:49:39
 * @LastEditTime: 2022-08-18 16:13:21
 * @LastEditors: xinguangding
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/api/procure/home.js
 */
import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
// const baseUrl = ''
// const baseUrl = 'http://192.168.18.97:8081'

// 采购人：进行中的项目-询比
export function getInquiryOrdersApi(query = {}, needLoading) {
  return request(
    {
      url: baseUrl + `/monitor/process/work/${query.identity}/inquiry-orders`,
      method: 'get',
      params: query
    },
    needLoading
  )
}

// 采购人：进行中的项目-招标采购
export function getBiddingOrdersApi(query = {}, needLoading) {
  return request(
    {
      url: baseUrl + `/monitor/process/work/${query.identity}/bidding-orders`,
      method: 'get',
      params: query
    },
    needLoading
  )
}

// 采购人：进行中的项目-招标委托
export function getEntrustProjectsApi(query = {}, needLoading) {
  return request(
    {
      url: baseUrl + '/monitor/process/work/purchaser/entrust-projects',
      method: 'get',
      params: query
    },
    needLoading
  )
}

// 采购人：进行中的项目-竞价
export function getCompetitionOrdersApi(query = {}, needLoading) {
  return request(
    {
      url:
        baseUrl + `/monitor/process/work/${query.identity}/competition-orders`,
      method: 'get',
      params: query
    },
    needLoading
  )
}
// 采购人：进行中的项目
export function getProjectListApi(params) {
  return request({
    url: baseUrl + `/monitor/project/search`,
    method: 'get',
    params
  })
}

// 采购人：进行中的项目-谈判（包含分项谈判）
export function getNegotiateOrdersApi(params) {
  return request({
    url: baseUrl + `/monitor/process/work/purchaser/negotiate-orders`,
    method: 'get',
    params
  })
}
